import Loadable from '../../components/loadable';

const ManageWebsiteBusinessDetails = Loadable({
  loader: () => import('../../pages/manage_website/business_details'),
});

angular.module('gym').value('ManageWebsiteBusinessDetails', ManageWebsiteBusinessDetails);
